import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { QueryConfig } from '@lib/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const customerAuthQueryDocument = graphql(`
  query CustomerAuth {
    customer {
      id
      email
      firstName
      lastName
    }
  }
`)
const customerQueryDocument = graphql(`
  query Customer {
    customer {
      id
      firstName
      lastName
      email
      addresses(first: 50) {
        edges {
          node {
            id
            address1
            address2
            city
            company
            countryCode
            email
            firstName
            lastName
            phone
            postalCode
            state
            formatted
            metadata {
              key
              value
            }
          }
        }
      }
      defaultBillingAddress {
        id
      }
      defaultShippingAddress {
        id
      }
      customerGroups {
        edges {
          node {
            id
            name
          }
        }
      }
      metadata {
        key
        value
      }
    }
  }
`)

export const getCustomer = () => {
  return execute(customerQueryDocument)
}

export const getCustomerQueryOptions = () => {
  return queryOptions({
    queryKey: ['customer'],
    queryFn: () => getCustomer(),
  })
}

type UseCustomerOptions = {
  queryConfig?: QueryConfig<typeof getCustomer>
}

export const useCustomer = ({ queryConfig }: UseCustomerOptions) => {
  return useQuery({
    ...getCustomerQueryOptions(),
    ...queryConfig,
  })
}
